function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#user_check_svg__clip0_956_77)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.851 9.322l1.865 1.865 3.73-3.73m-9.324-1.864a3.73 3.73 0 11-7.46 0 3.73 3.73 0 017.46 0zM4.849 20.51h7.086a2.984 2.984 0 002.984-2.983 4.475 4.475 0 00-4.476-4.476H6.341a4.475 4.475 0 00-4.476 4.476A2.984 2.984 0 004.85 20.51z",
  stroke: "#fff",
  strokeWidth: 1.748,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "user_check_svg__clip0_956_77"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h22.378v22.378H0z"
})));

var SvgUserCheck = function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgUserCheck;